import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN } from '@/util/roles';

export const routes = [
	{
		path: 'sectors',
		meta: {
			requireAuth: true,
			breadcrumb: 'Sectors',
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.SECTORS.DASHBOARD,
				component: () => {
					return import('@/views/depot/sectors/Dashboard.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
			{
				path: 'view-sectors',
				name: ROUTE_NAMES.DEPOT.SECTORS.OVERVIEW,
				component: () => {
					return import('@/views/depot/sectors/View-Sectors.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'View Sectors',
				},
			},
			{
				path: 'add-sector',
				name: ROUTE_NAMES.DEPOT.SECTORS.ADD_SECTOR,
				component: () => {
					return import('@/views/depot/sectors/Add-Sector.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Add Sector',
					minRole: ROLE_ADMIN,
				},
			},
		],
	},
];
